import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  root: {},
  content: {},
  footer: {
    minHeight: 38,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  footerText: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    paddingRight: 4
  },
  footerIcon: {
    fontSize: 14,
    color: theme.palette.text.secondary
  },
  footerIconCollapsed: {
    transform: "rotate(180deg)"
  },
  footerButton: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer"
  }
}));
